export const MAX_TABLE_DATA_PER_PAGE = 15;